import { render, staticRenderFns } from "./TreatyDetHelpList.vue?vue&type=template&id=501ef9db&"
import script from "./TreatyDetHelpList.vue?vue&type=script&lang=js&"
export * from "./TreatyDetHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports